import GeneralInformationTab from "../pages/Tabs/GeneralInformation";
import EventsTab from "../pages/Tabs/Events";
import LogRequestsTable from "@/common/components/LogRequestsTable";
import { CompanyData } from "@/features/company/types/company.type";
import UserBranchesAccesses from "../components/showUser/userBranchesAccesses";

export const userTabs = (userId: string, companyData?: CompanyData) => [
  {
    label: 'Dados gerais',
    value: '',
    body: <GeneralInformationTab companyData={companyData} />,
  },
  {
    label: 'Histórico de consumo',
    value: 'events',
    body: <EventsTab />,
  },
  {
    value: 'user-branch-access',
    label: 'Permissões nas filiais',
    hidden: companyData?.branch_hierarchy_for_user_access !== 'dynamic',
    operationKlassToCheckPermission: 'Client::UserBranchAccesses::Filter',
    body: <UserBranchesAccesses />
  },
  {
    label: 'Histórico de ações',
    value: 'actionsHistory',
    body: (
      <LogRequestsTable
        type="ClientUser"
        id={userId}
        detailsBasePath={`/users/${userId}/actionsHistory`}
      />
    ),
  },
];
